export function x(p) {
  return p[0];
}

export function y(p) {
  return p[1];
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/point.js
// module id = ds32
// module chunks = 0